var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',[_c('v-container',[_c('v-row',_vm._l((_vm.experiences),function(ref,i){
var icon = ref[0];
var number = ref[1];
var name = ref[2];
return _c('v-col',{key:i,attrs:{"cols":"6","md":"3"}},[_c('div',{staticClass:"text-center"},[_c('v-icon',{staticClass:"mb-3",attrs:{"size":"64","color":"green"},domProps:{"textContent":_vm._s(icon)}}),_c('div',{staticClass:"display-2 font-weight-bold mb-2",domProps:{"textContent":_vm._s(number)}}),_c('div',{staticClass:"text-uppercase",domProps:{"textContent":_vm._s(name)}})],1)])}),1)],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }